import MasterNav from './MasterNav.vue';
import NavService from './NavService';

MasterNav.NavService = NavService;

export default MasterNav;
export { NavService };
